// extracted by mini-css-extract-plugin
export default {"brand":"styles_brand__DvV0Z","main_section":"styles_main_section__m9fQ8","left_banner":"styles_left_banner__PVEiT","right_section":"styles_right_section__aN9ff"};